import {setInitialState} from '../../../utils/reducerOperations';

export const Default=()=>({
    fetchExecutiveOverviewApi:setInitialState(),
    activeItemIndex:0,
    carouselWidth:'calc(50vw - 63px)'
});